const BACK_API_BASE_URL = process.env.REACT_APP_BACK_API_BASE_URL;

export const getAllUser = async (setUsers) => {
    const url = `${BACK_API_BASE_URL}/api/user/load/allUserInfo`;
    
    try {
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Content-Type" : "application/json",
                "Authorization": sessionStorage.getItem('token'),
            },
        });

        if (response.ok) {
            const responseData = await response.json();
            
            const processResponseData = responseData.reduce((acc, item) => {
                
                acc[item.userId] = `${item.userName} (${item.email})`;
                return acc;
            }, {});
            setUsers(processResponseData)
        } else {
            if (response.status === 400) {
                throw new Error('Bad Request: Please check the request data.');
            } else {
                throw new Error(`Error: ${response.statusText}`);
            }
        }
    } catch (error) {
        // console.log(error);
    }
};

export const getAllBuilding = async (userId, buildings, setBuildings, setBuildingId) => {
    const params = new URLSearchParams({
        userId: userId,
    });
    const url = `${BACK_API_BASE_URL}/api/building/load/all?${params.toString()}`;

    try {
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": sessionStorage.getItem('token'),
            },
        });

        if (response.ok) {
            const responseData = await response.json();
            const processResponseData = responseData.reduce((acc, item) => {
                acc[item.id] = item.buildingName;
                return acc;
            }, {});
            if (JSON.stringify(processResponseData) !== JSON.stringify(buildings)) {
                setBuildings(processResponseData);
                setBuildingId(Object.keys(processResponseData)[0] || null);
            }
        } else {
            if (response.status === 400) {
                throw new Error('Bad Request: Please check the request data.');
            } else {
                throw new Error(`Error: ${response.statusText}`);
            }
        }
    } catch (error) {
        // console.log(error);
    }
};

export const saveSnapshot = async (date, buildingId, generatedData, to) => {
    const url = `${BACK_API_BASE_URL}/api/utilities/saveSnapshot`;

    const requestData = {
        date: date,
        buildingId: buildingId,
    };

    if (to === "elec") {
        requestData.elecContract = JSON.stringify(generatedData)
    } else if (to === "water") {
        requestData.waterContract = JSON.stringify(generatedData)
    } else if (to === "bill") {
        requestData.billContract = JSON.stringify(generatedData)
    }

    try {
        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": sessionStorage.getItem('token'),
            },
            body: JSON.stringify(requestData)
        });

        if (!response.ok) {
            if (response.status === 400) {
                throw new Error('Bad Request: Please check the request data.');
            } else {
                throw new Error(`Error: ${response.statusText}`);
            }
        }
    } catch (error) {
        // console.log(error);
    }
};

export const saveUtilities = async (date, buildingId, generatedData) => {
    const url = `${BACK_API_BASE_URL}/api/utilities/saveMonthInfo`;

    const updatedRoomUtilitiesInfoList = generatedData.roomUtilitiesInfoList.map(room => ({
        ...room,
        roomElecChangePrice: room.roomElecChangePrice,
    }));

    const updatedBuildingUtilitiesInfo = {
        ...generatedData.buildingUtilitiesInfo,
        buildingId: buildingId
    };

    const requestData = {
        date: date,
        buildingUtilitiesInfo: updatedBuildingUtilitiesInfo,
        roomUtilitiesInfoList: updatedRoomUtilitiesInfoList
    };

    try {
        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": sessionStorage.getItem('token'),
            },
            body: JSON.stringify(requestData)
        });

        if (!response.ok) {
            if (response.status === 400) {
                throw new Error('Bad Request: Please check the request data.');
            } else {
                throw new Error(`Error: ${response.statusText}`);
            }
        }
    } catch (error) {
        // console.log(error);
    }
};

export const getSnapshot = async (from, buildingId, date, setIsLoading, setTableData) => {
    const url = `${BACK_API_BASE_URL}/api/utilities/getSnapshot`;
    const requestData = {
        buildingId: buildingId,
        date: date
    };

    setIsLoading(true);

    try {
        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": sessionStorage.getItem('token'),
            },
            body: JSON.stringify(requestData)
        });

        if (response.ok) {
            const responseData = await response.json();
            
            if (from === "elec") {
                setTableData(JSON.parse(responseData.elecContract));
            } else if (from === "water") {
                setTableData(JSON.parse(responseData.waterContract))
            }
        } else {
            if (response.status === 400) {
                throw new Error('Bad Request: Please check the request data.');
            } else {
                throw new Error(`Error: ${response.statusText}`);
            }
        }
    } catch (error) {
        // console.log(error);
    } finally {
        setIsLoading(false);
    }
};

export const getBilling = async (buildingId, date, setIsLoading, setTableData, setTableBuildingData) => {
    const params = new URLSearchParams({
        buildingId: buildingId,
        date: date
    });
    const url = `${BACK_API_BASE_URL}/api/utilities/getBilling?${params.toString()}`;

    setIsLoading(true);

    try {
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": sessionStorage.getItem('token'),
            },
        });

        if (response.ok) {
            const responseData = await response.json();
            
            setTableData(responseData.roomUtilitiesInfoList)
            setTableBuildingData(responseData.buildingUtilitiesInfo)
        } else {
            if (response.status === 400) {
                setTableData([{
                    roomId: -1
                }])
            } else {
                throw new Error(`Error: ${response.statusText}`);
            }
        }
    } catch (error) {
        // console.log(error);
    } finally {
        setIsLoading(false);
    }
};

export const getUtilities = async (buildingId, date, setIsLoading, setTableData) => {
    const url = `${BACK_API_BASE_URL}/api/utilities/getMonthInfo`;
    const requestData = {
        buildingId: buildingId,
        date: date
    };

    setIsLoading(true);
    
    try {
        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": sessionStorage.getItem('token'),
            },
            body: JSON.stringify(requestData)
        });

        if (response.ok) {
            const responseData = await response.json();

            setTableData(responseData);
        } else {
            if (response.status === 400) {
                throw new Error('Bad Request: Please check the request data.');
            } else {
                throw new Error(`Error: ${response.statusText}`);
            }
        }
    } catch (error) {
        // console.log(error);
    } finally {
        setIsLoading(false);
    }
};

export const getSnapshotDate = async (buildingId, setAllowedMonths) => {
    const params = new URLSearchParams({
        buildingId: buildingId,
        category: "electricity"
    });
    const url = `${BACK_API_BASE_URL}/api/utilities/getSnapshotDates?${params.toString()}`;
    
    try {
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": sessionStorage.getItem('token'),
            },
        });

        if (response.ok) {
            const data = await response.json();
            setAllowedMonths(data);
        } else {
            if (response.status === 400) {
                throw new Error('Bad Request: Please check the request data.');
            } else {
                throw new Error(`Error: ${response.statusText}`);
            }
        }
    } catch (error) {
        // console.log(error);
    }
};

export const getArisuData = async (arisuDate, arisuUserName, arisuNumber, setIsLoadingArisu, updateArisuData, setArisuButtonDisable) => {
    const params = new URLSearchParams({
        date: arisuDate,
        userName: arisuUserName,
        arisuNumber: arisuNumber
    });
    const url = `${BACK_API_BASE_URL}/api/utilities/getArisuData?${params.toString()}`;

    setIsLoadingArisu(true);
    
    try {
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": sessionStorage.getItem('token'),
            },
        });

        if (response.ok) {
            const data = await response.json();
            updateArisuData(data);
        } else {
            if (response.status === 400) {
                throw new Error('Bad Request: Please check the request data.');
            } else {
                throw new Error(`Error: ${response.statusText}`);
            }
        }
    } catch (error) {
        // console.log(error);
    } finally {
        setIsLoadingArisu(false);
        setArisuButtonDisable(false)
    }
};